import { aapPixel } from '../pixels/aap'
import { event, GTMEvent, pageview } from './ga4'
import { getPixels } from './getPixels'
import { gtagsConversion } from '../pixels/gtags'
import { fbPixel } from '../pixels/facebook'
import { runPixels } from './runPixels'
import { twitterPixel } from '../pixels/twitter'

/**
 *
 * @param {FormSubmitResponse} data
 * @param {SubmitBody} submitBody
 * @returns {Promise<undefined>}
 */
export async function firePixels(data, submitBody) {
  console.time('firePixels')

  const eventID = submitBody.eventID
  const trid = submitBody.trid
  const campaign = submitBody.utm_campaign
  const oid = submitBody.oid

  const pixelData = {
    pixelFire: data.fields?.pixel_fire || null,
    lcLink: data.return_link || null,
    debtAmount: data.fields?.debt_amount || 0,
    affId: data.fields?.aff_id,
    submitted: true,
    unset: Date.now(),
    dedupe: data.dedupe,
  }

  // Downsell if no valid link is returned from backend
  if (!data.return_link) {
    GTMEvent({ action: 'downsell', params: {}, TRID: trid })
    return
  }

  // Fire pixels
  if (
    (submitBody.hide_pixels !== 1 && data.dedupe === 'no') ||
    campaign === '477' ||
    submitBody.test_pixel === '1'
  ) {
    // GTM events based on debt amount
    if (pixelData.debtAmount >= 10000) {
      pageview('/lead10/')
      event({ action: 'lead_10k', params: {} })
      GTMEvent({ action: 'lead_10k', params: {}, TRID: trid })
    }

    if (pixelData.debtAmount < 10000) {
      pageview('/lead_7.5k/')
      event({ action: 'lead_7.5k', params: {} })
      GTMEvent({ action: 'lead_7.5k', params: {}, TRID: trid })
    }

    try {
      const pixels = await getPixels({
        affId: pixelData.affId?.toString() || '',
        sub1: submitBody.sub1,
      })
      if (pixels) await runPixels(pixels, submitBody)
    } catch (error) {
      console.error('Error fetching pixels:', error)
    }

    await aapPixel()

    // GTM events
    await gtagsConversion('G-SHN3M1DWMW', {
      send_to: 'AW-11093474033/TMlNCK7Z0M4YEPH146kp',
    })

    // internal
    await twitterPixel('tw-opjfu-opjfz')
    await fbPixel('400186815856995', ['Lead', {}, { eventID }])

    // offer 64
    if (oid === '64') {
      await fbPixel('742220379900216', ['Lead', {}])
    }
  }

  console.timeEnd('firePixels')
}
